import config from '../config';
import { appendHoneyGuide } from '../lib/utils';

const { ASSETS_URL } = config;

const { honeyguideDefaultImage } = config;

const SEO = {
  landing: {
    title: 'HoneyGuide | To The Mountains!',
    description:
      'HoneyGuide is an Online Travel Agency specializing in the Everest Region of Nepal. We provide group treks, helicopter tours, flight booking, hotel booking, and trekking guide booking services for the Everest Region.',
    image: honeyguideDefaultImage,
  },
  explore: {
    title: appendHoneyGuide('Explore'),
    description:
      'Explore the Mountains of the World. Know everything about the Treks, Regions, and Destinations you are interested in.',
    image: honeyguideDefaultImage,
  },
  trekListings: {
    title: appendHoneyGuide('Treks'),
    description:
      'Here you will find both Guided and Self-Guided Treks. Find a trek that fits your budget and timeline. If not simply create one that does fit!! In the end, book with confidence that all of your money will go directly to the local community.',
    image: honeyguideDefaultImage,
  },
  placeListings: {
    title: appendHoneyGuide('Places'),
    description:
      'Know more about the villages you will pass during your trek. Whether you are looking to Book a Lodge or find Local Attractions, this will have you covered. With the Mountain Finder, you will know what mountains you can see and with Sightings, you will know what flowers, birds, and festivals to expect!! ',
    image: honeyguideDefaultImage,
  },
  flights: {
    title: appendHoneyGuide('Kathmandu to Lukla Flight at USD 168'),
    description:
      'Book your flight to Lukla online. At Direct Airline Prices. Secure Checkout. 72 hour cancellation. 24x7 hour support from people who know the mountains!!',
    image: 'https://s3.amazonaws.com/honeyguide/assets/book-lukla-flights-new.jpg',
  },
  checkList: {
    title: appendHoneyGuide('Trekking in Nepal - A Checklist'),
    description:
      'This is the quickest way to plan a Trek to Nepal!! This Complete Checklist covers stuff from Insurance to Gear, to Medicines, to Permits. Simply put, if you have only fifteen minutes to plan a trek to Nepal, this is where you should be!!',
    image: `${ASSETS_URL}/trekking-in-nepal-a-checklist2.jpg`,
  },
  safety: {
    title: appendHoneyGuide('Health and Safety Issues while Trekking in Nepal'),
    description:
      'This has everything you need to know to remain safe while Trekking in Nepal. From Water Safety to Altitude Illness, to a Complete Contact List of Emergency Services in Nepal.',
    image: `${ASSETS_URL}/health-and-safety-while-trekking-in-nepal.jpg`,
  },
  everest: {
    title: appendHoneyGuide('Everything about the Everest Base Camp Trek'),
    description:
      'Trekking to the Everest Base Camp in Nepal is in many ways like visiting a mountain museum. The only difference is that the things on display are all real.',
    image: `${ASSETS_URL}/every-thing-about-the-everest-base-camp-trek.jpg`,
  },
  annapurnaRegion: {
    title: appendHoneyGuide('Annapurna Region'),
    description:
      'The Annapurna Region is a rather large and diverse area. It encompasses the foothills close to Pokhara, the snow-capped peaks around the Annapurna Base Camp, and the trans-Himalayan Region of Manang and Mustang.',
    image: `${ASSETS_URL}/annapurna.jpg`,
  },
  annapurnaBaseCamp: {
    title: appendHoneyGuide('Everything about the Annapurna Base Camp Trekking Region'),
    description:
      'Imagine you are in the middle of the Colosseum and the walls are not 150 but 10,000 feet high and are made of rock, ice and snow. There you have it, that is what it is like to be at the Annapurna Base Camp. We think the base camp should be marked with a “Caution: Jaw Drop Ahead” sign at least during the full moons. And it has an approach to match. The trail goes through the heartland of the Gurungs who make a sizeable portion of the fearsome Gurkhas. It might come as a bit of a surprise to find them so friendly and peaceful, but look around; who wouldn’t be happy in such a tranquil landscape? If you are lucky, you might even get to see an audacious honey hunt in a precarious cliff side. The trail also passes through the most rewarding hawk watch site in Nepal and the rhododendrons are something to write home about. In short, you will love it!!',
    image: `${ASSETS_URL}/annapurna.jpg`,
  },
  annapurna: {
    title: appendHoneyGuide('Everything about the Annapurna Circuit Trek'),
    description:
      'The Annapurna Circuit is the ultimate trek when it comes to variety and adventure. With her you will shrug shoulders with polite Brahmins, gutsy Gurungs, regal Ghales, smiling Lobas and hospitable Thakalis. With her, you will earn bragging rights for scrambling past one of the highest mountain passes and gliding through one of the deepest river valley',
    image: `${ASSETS_URL}/annapurna.jpg`,
  },
  nepal: {
    title: appendHoneyGuide('The Hippest Intro to Nepal'),
    description:
      'Nepal is a country so expansive in its variety that it transcends the notion of big and small, a country so beautiful that you will keep coming back for more and a country with such depth that even after 10 visits you would have barely scratched the surface',
    image: `${ASSETS_URL}/nepal.jpg`,
  },
  careers: {
    title: appendHoneyGuide('Careers'),
    description:
      'Come, join our Team of Mountain Lovers!! HoneyGuide is a refuge for people who were too smart for school, too headstrong for teachers, too creative for banks, too motivated for an INGO and too adventurous for a routine job.',
    image: 'https://honeyguide.s3.amazonaws.com/assets/careers.jpg',
  },
  privacyPolicy: {
    title: appendHoneyGuide('Privacy Policy'),
    description:
      'We care deeply about your privacy and are committed to limit the amount of data we process.',
    image: honeyguideDefaultImage,
  },
  termsOfServices: {
    title: appendHoneyGuide('Terms of Service'),
    description:
      'These Terms of Service  constitute a legally binding agreement between you and HoneyGuide.',
    image: honeyguideDefaultImage,
  },
  guideListings: {
    title: appendHoneyGuide('Guides'),
    image: honeyguideDefaultImage,
    description:
      'Looking for a destination expert to accompany you on your trek? Here are experienced, certified and fun guides who can help you plan and execute your dream trek.',
  },
  about: {
    title: appendHoneyGuide('About Us'),
    description:
      'The trail to Gurusangpo Cave in Mustang was littered with blue asters, little purple rhododendrons, and the rare roscoe lily, as two trekkers slowly made their way past the avalanche debris, up the slippery slope, and to the famous cave. It was July of 2014 and the day was as overcast as it could be. However for a few minutes, the clouds would lift and Mt. Dhaulagiri, the seventh highest mountain in the world, would light up the eyes of the two trekkers. Their hearts and feet would stop for a few moments as they stood in awe at the mighty Dhaulagiri Icefall and the beautiful Dhaulagiri.',
    image: honeyguideDefaultImage,
  },
  // for partners
  bnb: {
    title: appendHoneyGuide('Bed And Breakfasts'),
    description:
      'Through HoneyGuide you can give accurate, Comprehensive and No-Strings-Attached Information to your friends. We strongly believe that trekkers should not be made to buy stuff through disinformation and fear.',
    image: honeyguideDefaultImage,
  },
  press: {
    title: appendHoneyGuide('Press Center'),
    description:
      'Introduce Transparency in Nepal’s Adventure Travel Industry through information so actionable that anyone will be confident to hit the trails  on their own. We believe that travel companies should not and need not depend upon fear and ignorance to sell tours.',
    image: honeyguideDefaultImage,
  },
  guide: {
    title: appendHoneyGuide('Guide'),
    description:
      'We understand that given your experience and expertise, you deserve to get paid more. We also understand that you wish to get some type of payment confirmation from the bookings you get through social media. HoneyGuide can help you achieve your goals.',
    image: honeyguideDefaultImage,
  },
  bloggers: {
    title: appendHoneyGuide('Bloggers'),
    description:
      'As avid mountain lovers ourselves, we understand that you wish to simply just quit  everything and keep traveling. While we do not have a fairy to make that happen, we have tried to create something that will take you a little bit closer to that goal.',
    image: honeyguideDefaultImage,
  },
  lodgeOwner: {
    title: appendHoneyGuide('Lodge Owners'),
    description:
      '  HoneyGuide understands that you are tired of giving out free rooms, interested in getting direct bookings, and unsure of how to increase your digital presence. And we are here to help.',
    image: honeyguideDefaultImage,
  },
  travelAgent: {
    title: appendHoneyGuide('Travel Agents'),
    description:
      ' Whether you are a single person travel company or a two thousand strong global giant, you will still need friends in high places. ;) HoneyGuide can help you make really good friends in the mountains!',
    image: honeyguideDefaultImage,
  },
  nr: {
    title: appendHoneyGuide('Non Residential Nepali'),
    description:
      ' You guys are the best ambassadors Nepal has, and we understand you wish to contribute to Nepal in any way you can.',
    image: honeyguideDefaultImage,
  },
  destinationPromotion: {
    title: appendHoneyGuide('Destination Promotion Organization'),
    description:
      'We understand that promoting a destination in the digital age can be daunting. How to reach out to trekkers? Which channels to use? How to create great content? How to be visible in Google Search? How much does it cost to create a mobile app?',
    image: honeyguideDefaultImage,
  },
  lodgeListings: placeName => ({
    title: appendHoneyGuide(`Lodges In ${placeName}`),
    description: '',
    image: honeyguideDefaultImage,
  }),
};

export default Object.freeze(SEO);



// WEBPACK FOOTER //
// ./src/constants/seo.js